import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios } from "./axiosActions";
import _ from "lodash";
import { getMasterDataUpdateSuccess } from "./location";

export const initialState = {
  loading: false,
  hasErrors: false,
  brandVoice: [],
  insertBrandVoice: [],
  updateBrandVoice: [],
  deleteBrandVoice: []
};

const brandVoiceSlice = createSlice({
  name: "brandVoice",
  initialState,
  reducers: {
    getBrandVoice: (state) => {
      state.loading = true;
    },
    getBrandVoiceSuccess: (state, { payload }) => {
      state.brandVoice = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getBrandVoiceFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getInsertBrandVoice: (state) => {
      state.loading = true;
    },
    getInsertBrandVoiceSuccess: (state, { payload }) => {
      state.insertBrandVoice = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getInsertBrandVoiceFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getUpdateBrandVoice: (state) => {
      state.loading = true;
    },
    getUpdateBrandVoiceSuccess: (state, { payload }) => {
      state.updateBrandVoice = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getUpdateBrandVoiceFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getDeleteBrandVoice: (state) => {
      state.loading = true;
    },
    getDeleteBrandVoiceSuccess: (state, { payload }) => {
      state.deleteBrandVoice = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getDeleteBrandVoiceFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
  },
});

export const {
  getBrandVoice,
  getBrandVoiceSuccess,
  getBrandVoiceFailure,
  getDeleteBrandVoice,
  getDeleteBrandVoiceSuccess,
  getDeleteBrandVoiceFailure,
  getUpdateBrandVoice,
  getUpdateBrandVoiceSuccess,
  getUpdateBrandVoiceFailure,
  getInsertBrandVoice,
  getInsertBrandVoiceSuccess,
  getInsertBrandVoiceFailure,
} = brandVoiceSlice.actions;
export const brandVoiceSelector = (state) => state.brandVoice;
export default brandVoiceSlice.reducer;

export function fetchBrandVoice(companyId) {
  return async (dispatch) => {
    dispatch(getBrandVoice());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/BrandVoice/GetBrandVoice?companyId=" + companyId,
        { params: params }
      );
      dispatch(getMasterDataUpdateSuccess({key:'brandVoice',data:data}))
      dispatch(getBrandVoiceSuccess(data));
    } catch (error) {
      dispatch(getBrandVoiceFailure());
    }
  };
}

export const triggerInsertBrandVoice = (data, companyId) => {
  return async (dispatch) => {
    dispatch(getInsertBrandVoice(data));
    try {
      const response = await postAxios("api/BrandVoice/InsertBrandVoice", {
        params: data,
      });
      await dispatch(getInsertBrandVoiceSuccess(response));
      dispatch(fetchBrandVoice(companyId));
    } catch (error) {
      dispatch(getInsertBrandVoiceFailure());
    }
  };
};

export const triggerUpdateBrandVoice = (data, companyId) => {
  return async (dispatch) => {
    dispatch(getUpdateBrandVoice(data));
    try {
      const response = await postAxios("api/BrandVoice/UpdateBrandVoice", {
        params: data,
      });
      await dispatch(getUpdateBrandVoiceSuccess(response));
      dispatch(fetchBrandVoice(companyId));
    } catch (error) {
      dispatch(getUpdateBrandVoiceFailure());
    }
  };
};

export function triggerDeleteBrandVoice(id, companyId) {
  return async (dispatch) => {
    dispatch(getDeleteBrandVoice());
    try {
      const params = { callTime: new Date() };
      const data = await getAxios(
        "api/BrandVoice/DeleteBrandVoice?brandVoiceId=" + id,
        {
          params: params,
        }
      );
      await dispatch(getDeleteBrandVoiceSuccess(data));
      dispatch(fetchBrandVoice(companyId));
    } catch (error) {
      dispatch(getDeleteBrandVoiceFailure());
    }
  };
}
